import { render, staticRenderFns } from "./RepositoryForm.vue?vue&type=template&id=e8006a9e&scoped=true&"
import script from "./RepositoryForm.vue?vue&type=script&lang=js&"
export * from "./RepositoryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.7.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8006a9e",
  null
  
)

export default component.exports